export default __webpack_public_path__ + "fonts/ic-master.svg";